import React, { useState, useEffect } from 'react';
import Button from '../Button/Button';
import './ProjectPage.scss';
import { FacebookShareButton, WhatsappShareButton, TelegramShareButton } from 'react-share';
import { FacebookIcon, WhatsappIcon, TelegramIcon } from 'react-share';
import { useStateValue } from '../../services/ContextProvider';
import { getOneProject } from '../../services/ProjectService';
import firebase from 'firebase';
import { MdDelete } from 'react-icons/md';
import { MdLocationOn } from 'react-icons/md';
import { BiUpArrow } from 'react-icons/bi';
import { RiCloseCircleFill, RiDeleteBin6Fill } from 'react-icons/ri';
import { signIn } from '../../services/AuthService';
import moment from 'moment';

const ProjectPage = ({ proId, checkFinishReading, clubProjecttId }) => {
    const [title, setTitle] = useState('');
    const [caption, setCaption] = useState('');
    const [thumbnail, setThumbnail] = useState('');
    const [description, setDescription] = useState('');
    const [imageURLS, setImageURLS] = useState([]);
    const [comment, setcomment] = useState({});
    const [commentList, setCommentList] = useState([]);
    const [projectDetails, setProjectDetails] = useState([]);
    const { oneprojectState, oneprojectDispatch } = useStateValue();
    const { userState } = useStateValue();
    const [location, setLocation] = useState('');
    const [date, setDate] = useState('');
    const [role, setRole] = useState('');
    const [checkAdmin, setCheckAdmin] = useState(false);
    const [changeUser, setChangeUser] = useState(true);
    const [thumbImageFileName, setThumbImageFileName] = useState('');
    const [imageFileList, setImageFileList] = useState([]);
    const [checkUser, setCheckUser] = useState(false);
    const [putCommentOnLoggin, setPutCommentOnLoggin] = useState(false);


    useEffect(async () => {
        //if (oneprojectState.oneproject.length === 0) {
        if (proId) {
            await getOneProject(oneprojectDispatch, proId);
        }
    }, [proId]);

    useEffect(async () => {
        if (userState.loggedUserData !== null) {
            setcomment({
                ...comment,
                userId: userState.loggedUserData.uid,
                userName: userState.loggedUserData.displayName,
                photo: userState.loggedUserData.photoURL,
            });
            if (putCommentOnLoggin) {
                await putComment({
                    ...comment,
                    userId: userState.loggedUserData.uid,
                    userName: userState.loggedUserData.displayName,
                    photo: userState.loggedUserData.photoURL,
                }, true);
                setPutCommentOnLoggin(false);
            }
        }
    }, [userState]);


    const handleCommentTyping = (value) => {
        setcomment({
            ...comment,
            text: value,
        });
    };

    useEffect(() => {
        if (oneprojectState.oneproject != null) {
            //console.log(oneprojectState.oneproject);
            setImageURLS(oneprojectState.oneproject.imageURLs);
            setDescription(oneprojectState.oneproject.description);
            setThumbnail(oneprojectState.oneproject.thumbnailimageURL);
            setCaption(oneprojectState.oneproject.caption);
            setTitle(oneprojectState.oneproject.title);
            setCommentList(oneprojectState.oneproject.comments || []);
            setDate(oneprojectState.oneproject.date);
            setLocation(oneprojectState.oneproject.loaction);
            setThumbImageFileName(oneprojectState.oneproject.thumbFileName);
            setImageFileList(oneprojectState.oneproject.fileNameArray);
        }

    }, [oneprojectState]);

    const submitComment = async (e) => {
        e.preventDefault();
        e.target.reset();
        if (userState.loggedUserData === null) {
            try {
                setPutCommentOnLoggin(true);
                await signIn();
            } catch (error) {
                console.log(error);
            }
        }
        else {
            try {
                await putComment(comment, true);
                //setCommentList(prev => [...prev, comment]);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const putComment = async (comment, add) => {
        let newComment;
        if (add) {
            newComment = {
                ...comment,
                commentID: Date.now().toString(),
                commentOn: firebase.firestore.Timestamp.now(),
            };
        }
        console.log(newComment);
        return firebase.firestore().collection('projects').doc(proId).update({
            comments: add ? firebase.firestore.FieldValue.arrayUnion(newComment) : firebase.firestore.FieldValue.arrayRemove(comment),
        })
            .then(() => {
                console.log('Document successfully updated!');

            })
            .catch((error) => {
                // The document probably doesn't exist.
                console.error('Error updating document: ', error);
            });
    };

    const handleReading = () => {
        checkFinishReading(false);
    };

    useEffect(() => {
        //console.log(userState.loggedUserData.role);
        if (userState.loggedUserData !== null) {
            if (userState.loggedUserData.role === 'admin') {
                console.log(userState.loggedUserData.role);
                setRole(userState.loggedUserData.role);
                setCheckAdmin(true);
                setCheckUser(true);
            }
        } else {
            setCheckUser(false);
            console.log('no user');
        }
    }, [changeUser, checkUser]);

    useEffect(() => {
        setChangeUser(!changeUser);
        setCheckAdmin(false);
        setCheckUser(false);
    }, [userState.loggedUserData]);

    //useEffect(() => {
    //    console.log(userState.loggedUserData.uid);
    //}, []);

    const deleteProject = async () => {

        var storage = firebase.storage();
        var storageRef = storage.ref();


        var desertRef = storageRef.child('projectimages/' + thumbImageFileName);
        await desertRef.delete().then(() => {
            console.log('deleted');
        }).catch((error) => {
            console.log(error);
        });

        imageFileList.forEach(async (file) => {
            var desertRef = storageRef.child('projectimages/' + file);
            await desertRef.delete().then(() => {
                console.log('deleted');
            }).catch((error) => {
                console.log(error);
            });
        });
        deleteProjectDoc();
    };

    const deleteProjectDoc = () => {
        firebase.firestore().collection('projects').doc(proId).delete().then(() => {
            console.log('Document successfully deleted!');
            checkFinishReading(false);
        }).catch((error) => {
            console.error('Error removing document: ', error);
        });
    };

    const deleteComment = async (comment) => {
        console.log(comment);
        try {
            await putComment(comment, false);
            // setCommentList(prev => prev.filter(com => com.commentID !== comment.commentID));
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className="container-md">
            <div className="projectpage-content">

                <div>
                    <h2 className="leoprojectpage-title mt-3 m-0">{title}</h2>
                    <p className="leoproject-author pt-3">{caption}</p>

                    <div className="projectpage-btn-group">
                        <div className="project-page-socialmedia-share">
                            <p className="projectpage-social-media-share-title">Share us on</p>
                            <FacebookShareButton url={`https://www.monarchleos.org/projects?_id=${clubProjecttId}`} quote={`Project ${title} by Leo Club of Colombo Monarch`} hashtag='#ColomboMonarchLeos'>
                                <FacebookIcon logoFillColor="white" round={true} className="project-page-socialmedia-icon" />
                            </FacebookShareButton>

                            <WhatsappShareButton url={`http://www.monarchleos.org/projects?_id=${clubProjecttId}`} title={`Project ${title} by Leo Club of Colombo Monarch`}>
                                <WhatsappIcon logoFillColor="white" round={true} className="project-page-socialmedia-icon" />
                            </WhatsappShareButton>

                            <TelegramShareButton url={`http://www.monarchleos.org/projects?_id=${clubProjecttId}`} title={`Project ${title} by Leo Club of Colombo Monarch`}>
                                <TelegramIcon logoFillColor="white" round={true} className="project-page-socialmedia-icon" />
                            </TelegramShareButton>
                        </div>

                        {checkAdmin &&
                            <div className="delete-project-btn-container">
                                <button type="button" class="btn btn-danger" onClick={deleteProject}>Delete this project</button>
                            </div>
                        }

                    </div>
                </div>

                <div>
                    <div className="thumb-img-container">
                        <img src={thumbnail} alt="" className="projectpage-thumbimage mb-4" />
                    </div>
                    <div className="row">
                        <p><MdLocationOn /> <b>{location} .</b> {date}</p>
                        {/* <p><MdLocationOn /> <b>{location}</b></p> */}
                    </div>

                    <p className="projectpage-description">{description}</p>

                </div>

                <div className="project-page-images-content">
                    {
                        imageURLS.map((image, index) => {
                            return (
                                <img src={image} alt="" className="projectpage-images p-2" key={index} />
                            );
                        })
                    }

                </div>

                <div className="row container-md comment-section-container2 mt-3">
                    <div className="col-md-8 m-0 p-0">
                        <h2 className="projectpage-comment-heading m-0 p-0">Leave us a comment</h2>
                        <p className="project-page-comment-subheading mt-2">We value your comment and it will help us to more improvements.</p>
                    </div>
                    <div className="col-md-4">
                        <div className="project-page-socialmedia-share">
                            <p className="projectpage-social-media-share-title">Share us on</p>
                            <FacebookShareButton url={`https://www.monarchleos.org/projects?_id=${clubProjecttId}`} quote={`Project ${title} by Leo Club of Colombo Monarch`} hashtag='#ColomboMonarchLeos'>
                                <FacebookIcon logoFillColor="white" round={true} className="project-page-socialmedia-icon" />
                            </FacebookShareButton>

                            <WhatsappShareButton url={`https://www.monarchleos.org/projects?_id=${clubProjecttId}`} title={`Project ${title} by Leo Club of Colombo Monarch`}>
                                <WhatsappIcon logoFillColor="white" round={true} className="project-page-socialmedia-icon" />
                            </WhatsappShareButton>

                            <TelegramShareButton url={`https://www.monarchleos.org/projects?_id=${clubProjecttId}`} title={`Project ${title} by Leo Club of Colombo Monarch`}>
                                <TelegramIcon logoFillColor="white" round={true} className="project-page-socialmedia-icon" />
                            </TelegramShareButton>
                        </div>
                    </div>


                </div>


                <form onSubmit={submitComment}>
                    <div class="form-group mb-2">
                        <textarea class="form-control" id="exampleFormControlTextarea1" placeholder="Type your comment here" rows="3" onChange={(e) => handleCommentTyping(e.target.value)}></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary">Post Comment</button>

                </form>
                <br />
                <br />
                <hr />
                <br />


                {

                    <div>
                        {
                            commentList.slice(0).reverse().map((comment, index) => {
                                return (
                                    <div key={index}>
                                        <div className="comment-section mb-4">
                                            <div class="comment-view d-flex flex-row">
                                                <div class="px-4  py-2">
                                                    <div class="comment-img"> <img src={comment.photo} className="rounded-circle" width="70px" alt="user" /> </div>
                                                </div>
                                                <div class="p-2 ml-4">
                                                    <div class="comment-description">
                                                        <div className="d-flex">
                                                            <div>
                                                                <h5>{comment.userName} <span class="comment_date"> {comment.commentOn
                                                                    ? `${moment(
                                                                        comment.commentOn.seconds * 1000
                                                                    ).format('LLL')}`
                                                                    : 'Date not mentioned'}</span></h5>
                                                            </div>

                                                            {userState.loggedUserData !== null && userState.loggedUserData.uid === comment.userId &&
                                                                <div
                                                                    className="comment-deleteicon-container2 px-3"
                                                                    onClick={async () => { await deleteComment(comment); console.log(comment.commentID); }}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    <span><RiDeleteBin6Fill className="comment-delete-icon2" /></span>
                                                                </div>
                                                            }
                                                        </div>

                                                        <p>{comment.text}</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );

                            })
                        }
                    </div>
                }


                <div className="finish-reading-button-container" onClick={handleReading} >
                    <BiUpArrow className="finish-reading-icon" />
                </div>




            </div>
        </div>
    );
};

export default ProjectPage;
